<template>
  <v-app light :class="$route.name">
    <router-view></router-view>
    <!-- </v-container> -->
    <!-- <notifications group="main" /> -->
    <!-- </v-content> -->
  </v-app>
</template>

<script>
  // import Vue from 'vue'

  export default {
    created () {
      this.fetchEnterprise()
      this.menuList = []
      this.setBreadCrumbs()
    },
    data () {
      return {
        drawer: false,
        enterprise: null,
        menuList: [],
        breadcrumbs: [],
        right: true,
        rightDrawer: false,
        title: 'Vivid Arts Pro'
      }
    },
    watch: {
      '$route': function (to, from) {
        console.log('Route change', to, from)
        this.setBreadCrumbs()
      }
    },
    methods: {
      fetchEnterprise () {
        let url = this.$store.state.apiURL + '/v2/auth/enterprise'
        let payload = {
          'origin': window.location.origin
        }

        this.axios
          .post(url, payload, this.$store.state.axiosConfig)
          .then((response) => {
            console.log('auth enterprise post response', response)
            if (response.data.success && response.data.count) {
              let enterprise = response.data.enterprise
              this.enterprise = enterprise
              this.$store.commit('setEnterprise', {enterprise: enterprise})
              this.$store.commit('setConfig', {config: {
                logoURL: enterprise.logoURL,
                name: enterprise.name,
                supportEmail: enterprise.supportEmail,
                themeColor: enterprise.themeColor
              }})
            } else {
              let title = 'Enterprise failed'
              let text = response.data.msg ? response.data.msg : 'Failed to find enterprise'
              console.lgo(title, text)
              // this.notify(title, text)
            }
          })
      },
      showNavDrawer () {
        if (this.$route.name === 'Login' || this.$route.name === 'BuildTour' || this.$route.name === 'TourDetail' || this.$route.name === 'TourDetailWithUser' || this.$route.name === 'ArtistsDirectory' || this.$route.name === 'ArtistProfile' || this.$route.name === 'PlacesDirectory' || this.$route.name === 'PlaceProfile' || this.isArtists()) {
          return false
        }
        return true
      },
      isArtists () {
        return (typeof window.VividArts.urid !== 'undefined' && parseInt(window.VividArts.urid) === 3)
      },
      setBreadCrumbs () {
        console.log(this.$route)
        this.breadcrumbs = [
          {
            text: this.$route.name,
            disabled: false,
            href: {name: 'ArtistsDirectory'}
          }
        ]
      },
      showToolbar () {
        if (this.$route.name === 'Login' || this.$route.name === 'BuildTour' || this.$route.name === 'TourDetail' || this.$route.name === 'TourDetailWithUser' || this.$route.name === 'ArtistsDirectory' || this.$route.name === 'ArtistProfile' || this.$route.name === 'PlacesDirectory' || this.$route.name === 'PlaceProfile') {
          return false
        }
        return true
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
  .list__tile > a {
    width: 100%;
    height: 100%;
  }
  .list__tile > a > div {
    float: left;
  }
</style>
<style>

</style>



// WEBPACK FOOTER //
// App.vue?4fd73a07